﻿module.exports = {
    bindings: {
        groups: '<'
    },
    templateUrl: 'good/components/measure-many-condition-buttons.html'
};
